import { useState } from 'react';
import { Link } from 'react-router-dom';

const reviews = [
  {
    name: 'Maria T.',
    location: 'Ormond Beach, FL',
    rating: 5,
    text: 'Dippel\'s completely transformed our backyard. The paver patio is absolutely stunning, and the team was professional from start to finish. Highly recommend for anyone in Ormond Beach looking for quality outdoor work.',
    service: 'Patio Pavers',
    initial: 'M',
  },
  {
    name: 'James R.',
    location: 'Daytona Beach, FL',
    rating: 5,
    text: 'Got a new vinyl fence installed last month. The crew was on time, cleaned up after themselves, and the fence looks fantastic. Pricing was fair and transparent. Will definitely use Dippel\'s again.',
    service: 'Vinyl Fence',
    initial: 'J',
  },
  {
    name: 'Sandra K.',
    location: 'Port Orange, FL',
    rating: 5,
    text: 'We hired Dippel\'s for sod installation and landscape beds. The entire property looks like a professional resort now. Their owner truly knows his craft — you can tell he\'s formally trained.',
    service: 'Landscape Installation',
    initial: 'S',
  },
  {
    name: 'Tom & Lisa B.',
    location: 'New Smyrna Beach, FL',
    rating: 5,
    text: 'The landscape lighting they installed around our home is breathtaking at night. We\'ve had so many compliments from neighbors. The team was knowledgeable and truly delivered above and beyond.',
    service: 'Landscape Lighting',
    initial: 'T',
  },
  {
    name: 'Carlos M.',
    location: 'Palm Coast, FL',
    rating: 5,
    text: 'Had a custom workshop shed built by Dippel\'s. The quality is incredible — solid construction, great finish. The whole process from quote to completion was seamless. Best contractor I\'ve worked with.',
    service: 'Workshop Shed',
    initial: 'C',
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  const prev = () => setActive((p) => (p - 1 + reviews.length) % reviews.length);
  const next = () => setActive((p) => (p + 1) % reviews.length);

  const visible = [
    reviews[(active) % reviews.length],
    reviews[(active + 1) % reviews.length],
    reviews[(active + 2) % reviews.length],
  ];

  return (
    <>
      <section className="bg-charcoal py-28 px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
            <div>
              <p className="text-gold font-sans text-[11px] font-semibold tracking-[0.28em] uppercase mb-4 flex items-center gap-3">
                <span className="h-px w-8 bg-gold inline-block"></span>
                Client Reviews
              </p>
              <h2 className="font-serif text-white font-bold" style={{ fontSize: 'clamp(32px, 3.2vw, 48px)' }}>
                What Florida Homeowners Say
              </h2>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center gap-4">
              <div className="flex items-center gap-2">
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => <i key={i} className="ri-star-fill text-gold text-sm"></i>)}
                </div>
                <span className="text-white/60 text-sm">Top-Rated on Google</span>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={prev}
                  className="w-10 h-10 flex items-center justify-center border border-white/15 text-white/60 rounded-full hover:border-gold hover:text-gold transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-s-line text-lg"></i>
                </button>
                <button
                  onClick={next}
                  className="w-10 h-10 flex items-center justify-center border border-white/15 text-white/60 rounded-full hover:border-gold hover:text-gold transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Review cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {visible.map((r, i) => (
              <div
                key={`${active}-${i}`}
                className={`bg-white/5 border rounded-2xl p-7 transition-all duration-500 ${
                  i === 0 ? 'border-gold/30 bg-white/8' : 'border-white/8'
                }`}
              >
                {/* Stars */}
                <div className="flex gap-0.5 mb-5">
                  {[...Array(r.rating)].map((_, j) => (
                    <i key={j} className="ri-star-fill text-gold text-sm"></i>
                  ))}
                </div>

                {/* Quote icon */}
                <i className="ri-double-quotes-l text-gold/20 text-4xl font-serif leading-none block mb-2"></i>

                {/* Text */}
                <p className="text-white/65 text-[14px] leading-relaxed mb-7 italic">{r.text}</p>

                {/* Author */}
                <div className="flex items-center justify-between pt-5 border-t border-white/8">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-forest rounded-full font-bold text-white text-sm flex-shrink-0">
                      {r.initial}
                    </div>
                    <div>
                      <p className="text-white font-semibold text-sm">{r.name}</p>
                      <p className="text-white/40 text-xs flex items-center gap-1">
                        <i className="ri-map-pin-line text-xs"></i>
                        {r.location}
                      </p>
                    </div>
                  </div>
                  <span className="text-[10px] bg-gold/10 text-gold font-medium px-2.5 py-1 rounded-full whitespace-nowrap border border-gold/20">
                    {r.service}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-1.5 mt-8">
            {reviews.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`rounded-full transition-all duration-300 cursor-pointer ${
                  i === active ? 'w-6 h-2 bg-gold' : 'w-2 h-2 bg-white/20 hover:bg-white/40'
                }`}
                aria-label={`Review ${i + 1}`}
              />
            ))}
          </div>

          {/* Google link */}
          <div className="text-center mt-8">
            <a
              href="https://www.google.com/maps/place/Dippel%27s+Outdoor+Services/@28.8555939,-81.0881054,12z"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 border border-white/15 text-white/60 text-sm font-medium px-6 py-3 rounded-full hover:border-gold/40 hover:text-white transition-all whitespace-nowrap"
            >
              <i className="ri-google-fill text-gold"></i>
              Read All Google Reviews
            </a>
          </div>
        </div>
      </section>

      {/* Post-testimonials CTA */}
      <section className="bg-stone py-16 px-6 border-b border-stone-dark">
        <div className="max-w-4xl mx-auto text-center">
          <p className="font-serif text-charcoal text-2xl font-bold mb-3">
            Join hundreds of satisfied homeowners across Florida&apos;s east coast.
          </p>
          <p className="text-charcoal-muted text-base mb-8">
            Your premium outdoor transformation starts with a free, no-pressure design consultation.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-charcoal text-white font-bold px-9 py-4 rounded-full hover:bg-forest transition-colors whitespace-nowrap"
            >
              <i className="ri-pencil-ruler-2-line"></i>
              Request Your Design Consultation
            </Link>
            <a
              href="tel:3863014399"
              className="inline-flex items-center justify-center gap-2 border border-charcoal/20 text-charcoal font-semibold px-8 py-4 rounded-full hover:bg-white hover:border-charcoal/40 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-fill text-gold"></i>
              (386) 301-4399
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
